import Dashboard  from './Dashboard';

export default Dashboard


// WEBPACK FOOTER //
// ./src/app/views/affiliate/dashboard/index.js